import React from 'react'
import t from 'prop-types'

import { Button, Form } from 'components/UI'

class LoginForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: props.email || '',
      username: props.username || '',
      password: '',
    }
  }

  onSubmit = event => {
    event.preventDefault()
    this.props.onSubmit(this.state.username, this.state.password)
  }

  changeUsername = value => {
    this.setState({ username: value })
  }

  changePassword = value => {
    this.setState({ password: value })
  }

  render () {
    const {
      error,
      email,
    } = this.props

    return (
      <form onSubmit={this.onSubmit}>
        <div>{error}</div>
        <div>{email}</div>
        <Form.Text
          big
          type='email'
          value={this.state.username}
          onChange={this.changeUsername}
          placeholder='Email'
        />
        <Form.Text
          big
          type='password'
          value={this.state.password}
          onChange={this.changePassword}
          placeholder='Password'
        />

        <Button
          fluid
          big
        >
          Login
        </Button>
      </form>
    )
  }
}

LoginForm.propTypes = {
  onSubmit: t.func,
  clearCache: t.func,
  username: t.string,
  error: t.string,
  email: t.string,
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.jsx